import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import { PriceActions, PRICE_STATE_NAMESPACE } from './price.module-types';

export const dispatchPriceAction: DispatchAction<PriceActions> = getDispatch(
  PRICE_STATE_NAMESPACE
);
